import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="distance"
export default class extends Controller {
  static targets = ["away"]
  static values = {
    latitude: Number,
    longitude: Number
  }

  connect() {
    console.debug("DistanceController connected")
    // Check if we have valid latitude and longitude values
    if (this.hasLatitudeValue && this.hasLongitudeValue &&
        !isNaN(this.latitudeValue) && !isNaN(this.longitudeValue)) {

      // Set up position update callback to automatically recalculate distance
      this.positionUpdateCallback = (position) => {
        this.updateDistanceText(position);
      };
      window.onPositionUpdate(this.positionUpdateCallback);

      // Initial update
      this.updateDistance();
    } else {
      this.awayTarget.textContent = "Unknown";
    }

    document.addEventListener("turbo:frame-render", this.handleTurboFrame.bind(this));
  }

  disconnect() {
    // Remove event listeners when controller is disconnected
    document.removeEventListener("turbo:frame-render", this.handleTurboFrame.bind(this));

    // Remove position update callback
    if (this.positionUpdateCallback) {
      window.offPositionUpdate(this.positionUpdateCallback);
      this.positionUpdateCallback = null;
    }
  }

  handleTurboFrame() {
    // This will be called when a new turbo frame is rendered
    // Fresh controllers will connect automatically when rendered
    // so we don't need to manually trigger them
    // This is just a hook for future extensions if needed
  }

  updateDistanceText(currentPosition) {
    const currentLatitude = currentPosition.coords.latitude;
    const currentLongitude = currentPosition.coords.longitude;
    const discoveryLatitude = this.latitudeValue;
    const discoveryLongitude = this.longitudeValue;

    // Use the calculateDistance function from application.js
    // distance is in m
    const distance = calculateDistance(
      currentLatitude,
      currentLongitude,
      discoveryLatitude,
      discoveryLongitude
    );

    // Format distance display
    let distanceText;
    if (distance < 1000) {
      // Convert to meters if less than 1km
      distanceText = `${Math.round(distance)} m`;
    } else if (distance < 10000) {
      distanceText = `${(distance / 1000).toFixed(1).toLocaleString()} km`;
    } else {
      distanceText = `${Math.round(distance / 1000).toLocaleString()} km`;
    }

    this.awayTarget.textContent = distanceText;
  }

  async updateDistance() {
    // Use the global getCurrentPosition function
    if (window.currentPosition) {
      // If we already have a position, use it
      this.updateDistanceText(window.currentPosition);
    } else {
      try {
        const position = await window.getCurrentPosition();
        this.updateDistanceText(position);
      } catch (error) {
        console.error("Error getting location:", error);
        this.awayTarget.textContent = "Location Service N/A";
      }
    }
  }
}
